<template>
  <div>
    <loading-overlay :value="loading" />
    <v-alert
      v-for="item in customerRevisionNotes"
      :key="item.clientName"
      border="left"
      class="revision-request"
      color="orange"
      dense
      outlined
      text
    >
      <span class="revision-note-client-name">{{ item.clientName }}</span>
      requests that you make the following revisions to your W-9:
      {{ item.note }}
      <br />
      Select the Add W-9 button to submit a revised form.
    </v-alert>
    <div class="text-right mb-2">
      <yellow-button
        color="primary"
        @click="
          logEvent('Clicked button to Add W9', { Where });
          navUpload();
        "
      >
        Add W-9
      </yellow-button>
    </div>
    <v-data-table
      :headers="headers"
      :items="w9s"
      :options="tableOptions"
      class="main-table"
      disable-sort
      hide-default-footer
    >
      <template v-slot:item="{ item }">
        <tr :key="item.id">
          <td>
            {{ item.filename }}
          </td>
          <td>{{ item.uploadDate }}</td>
          <td>{{ (item.customerNames || []).join(", ") }}</td>
          <td class="text-right">
            <v-btn
              class="primary--text tertiary"
              color="secondary"
              depressed
              height="32px"
              title="Download"
              width="32px"
              @click="
                logEvent('Clicked button to download W9', { Where });
                downloadW9(item.id);
              "
            >
              <v-icon>mdi-download</v-icon>
            </v-btn>
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import { get, getDownloadFilename, getPDF } from "@/services/request";
import { saveFile } from "@/services/download";
import { revisionRequestNotesAPI, w9API, w9DownloadAPI } from "@/services/api";
import YellowButton from "@/components/providertrust/buttons/SmallYellowButton";
import LoadingOverlay from "@/components/LoadingOverlay";

const tableOptions = {
  itemsPerPage: -1
};

export default {
  name: "W9Table",
  components: {
    LoadingOverlay,
    YellowButton
  },
  inject: ["nav", "Where"],
  data: () => ({
    w9s: [],
    customerRevisionNotes: [],
    headers: [
      { text: "W-9", value: "filename" },
      { text: "Upload Date", value: "uploadDate" },
      { text: "Customer Name", value: "customers" },
      { text: " ", value: "action", align: "end" }
    ],
    tableOptions,
    loading: true
  }),
  created() {
    Promise.all([this.loadW9(), this.loadRevisionNotes()]).then(() => {
      this.loading = false;
    });
  },
  methods: {
    loadW9() {
      return get(w9API).then(response => {
        if (response && response.data) {
          this.w9s = response.data;
          if (this.action === "table") {
            this.navUpload();
          }
        }
      });
    },
    loadRevisionNotes() {
      return get(revisionRequestNotesAPI, {
        type: "W9",
        incompleteOnly: true
      }).then(response => {
        if (response && response.data) {
          this.customerRevisionNotes = response.data;
        }
      });
    },
    downloadW9(fileEntityId) {
      console.log(fileEntityId);
      getPDF(w9DownloadAPI.getUrl(fileEntityId))
        .then(response => {
          saveFile(response.data, getDownloadFilename(response));
        })
        .catch(e => console.error("Error downloading W9 PDF", e));
    },
    navUpload() {
      this.nav.w9Upload();
    }
  }
};
</script>
<style lang="sass" scoped>
.tertiary.v-btn:not(.v-btn--round).v-size--default
  padding: 0
  min-width: 0

.revision-request
  font-style: italic
  font-size: 0.875rem !important

.revision-note-client-name
  font-weight: bold
</style>
